<div class="container">
    <div class="row">
        <div class="col-xs-12">
            <div class="ib-layout__header ib-layout__header--title">
                <h1 class="ib-heading ib-heading--type-1">
                    {{'PAYMENTS_PAGE_TITLE'|translate }}
                </h1>
            </div>
        </div>
    </div>
    <div class="row">
        <div id="pmt-container" class="col-md-12 col-lg-8">
        </div>
        <div class="col-md-12 col-lg-4 u-mt-medium u-mb-medium">
            <!--Summary-->
            <ng-react [component]="summaryComponent.component" [props]="summaryComponent.props"></ng-react>
        </div>
    </div>
</div>
